import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { FiChevronRight, FiClock, FiHash } from "react-icons/fi";
import { GiSoccerBall, GiStrikingArrows } from "react-icons/gi";

const SelectedMatchesCard = ({ match }) => {
  const { t } = useTranslation();
  const isMix = match?.gamblingTypeId === 2;
  const isInPlay = String(match?.status || "").toLowerCase() === "inplay";
  const amount = Number(match?.amount || 0).toLocaleString(undefined, {
    maximumFractionDigits: 0,
  });

  return (
    <article className="rounded-lg border border-primary/40 bg-header_green/55 p-3 shadow-lg shadow-black/15 transition hover:border-white/25 hover:bg-header_green/70 active:scale-[0.99]">
      <div className="flex items-start justify-between gap-3 border-b border-white/10 pb-2.5">
        <div className="flex min-w-0 items-center gap-2.5">
          <div className="flex h-9 w-9 flex-none items-center justify-center rounded-lg bg-white/10 text-emerald-100">
            {isMix ? (
              <GiStrikingArrows className="h-4.5 w-4.5" />
            ) : (
              <GiSoccerBall className="h-4.5 w-4.5" />
            )}
          </div>
          <div className="min-w-0">
            <h2 className="text-sm font-semibold leading-[1.8] text-white">
              {isMix ? t("maungg") : t("body")}
            </h2>
            <p className="flex items-center gap-1.5 font-sans text-[10px] text-white/40">
              <FiClock className="h-3 w-3" />
              {moment(match?.createdDate).format("DD MMM YYYY · h:mm A")}
            </p>
          </div>
        </div>

        <div className="flex flex-none items-center gap-1.5">
          <span className={`rounded-md border px-2 py-1 font-sans text-[9px] font-semibold uppercase tracking-wide ${
            isInPlay
              ? "border-emerald-300/20 bg-emerald-300/15 text-emerald-200"
              : "border-white/10 bg-white/5 text-white/50"
          }`}>
            {isInPlay ? "Live" : match?.status || "Pending"}
          </span>
          <FiChevronRight className="h-4 w-4 text-white/30" />
        </div>
      </div>

      <div className={`mt-2.5 grid gap-2 ${isMix ? "grid-cols-3" : "grid-cols-2"}`}>
        <InfoItem
          label={t("BetID") || "Bet ID"}
          value={match?.postingNo || "—"}
          icon={<FiHash className="h-3 w-3" />}
        />
        <InfoItem label={t("betAmount")} value={amount} highlighted />
        {isMix && <InfoItem label={t("teamCount")} value={match?.teamCount || 0} />}
      </div>
    </article>
  );
};

const InfoItem = ({ label, value, highlighted, icon }) => (
  <div className="min-w-0 rounded-lg bg-black/15 px-2.5 py-2">
    <p className="flex items-center gap-1 truncate text-[9px] leading-[1.8] text-white/40">
      {icon}
      <span className="truncate">{label}</span>
    </p>
    <p className={`mt-0.5 truncate font-sans text-xs font-semibold ${highlighted ? "text-emerald-200" : "text-white"}`}>
      {value}
    </p>
  </div>
);

export default SelectedMatchesCard;
